import React from 'react';
import { ArrowUpRight, Users, Megaphone, Palette, Search, Mail, Compass, Type, Camera } from 'lucide-react';
import { SERVICES } from '../mock';
import Reveal from './Reveal';

const ICONS = { Users, Megaphone, Palette, Search, Mail, Compass, Type, Camera };

export default function Services() {
  const handleClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="servizi" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal variant="fade">
          <div className="flex items-start gap-3 mb-10">
            <span className="text-[#1e6cb0] font-bold text-[14px] tracking-[0.18em]">05</span>
            <span className="w-10 h-px mt-3 bg-[#1e6cb0]/60" />
            <span className="text-[12px] tracking-[0.2em] uppercase font-semibold text-neutral-500">
              Gli altri servizi
            </span>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <Reveal as="h2" variant="up" delay={80} className="lg:col-span-7 heading-mega text-[42px] sm:text-[56px] md:text-[72px] text-neutral-900">
            Il sito è un inizio.<br />
            Noi gestiamo <span className="text-[#1e6cb0]">tutto il resto.</span>
          </Reveal>
          <Reveal as="p" variant="up" delay={220} className="lg:col-span-5 text-[16px] leading-relaxed text-neutral-600 lg:mt-6">
            Social, advertising, SEO, brand, video, email. Un unico partner invece di cinque
            fornitori da tenere insieme con lo scotch.
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.n} variant="up" delay={(idx % 4) * 90} duration={700}>
              <article
                className="relative bg-white border border-black/5 rounded-3xl p-6 card-hover h-full"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-11 h-11 rounded-xl bg-[#dbeafe] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#1e6cb0]" />
                  </div>
                  <span className="text-[12px] font-semibold tracking-widest text-neutral-400">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-display text-[20px] font-bold text-neutral-900 mb-2">
                  {s.title}
                </h3>
                <p className="text-[14px] leading-relaxed text-neutral-600 mb-5">
                  {s.desc}
                </p>
                <ul className="flex flex-wrap gap-1.5">
                  {s.tags.map((t) => (
                    <li
                      key={t}
                      className="text-[11px] tracking-wide font-medium text-neutral-700 bg-neutral-100 border border-black/5 px-2.5 py-1 rounded-full"
                    >
                      {t}
                    </li>
                  ))}
                </ul>
              </article>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 p-8 md:p-10 rounded-3xl bg-gradient-to-br from-[#e0f2fe] to-[#dbeafe] border border-black/5">
          <p className="max-w-2xl text-[16px] leading-relaxed text-neutral-700">
            Parti dal sito e aggiungi il resto strada facendo, oppure prendi il pacchetto insieme.
            Nel questionario ci dici cosa ti serve. Se qualcosa non serve davvero,
            te lo diciamo noi per primi.
          </p>
          <a
            href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20parlare%20di%20un%20servizio."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#1e6cb0] text-white px-7 py-4 rounded-full font-semibold btn-glow whitespace-nowrap"
          >
            Scrivimi su WhatsApp <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
